var map = {
	"./add_prefs.svg": "1bd3",
	"./address_pin.svg": "d2c9",
	"./alert-rounded-red.svg": "f981",
	"./alert.svg": "aa06",
	"./all-banks.svg": "3e27",
	"./arrow-curve-right.svg": "f5c8",
	"./arrow-down-full.svg": "6e5c",
	"./arrow-down-no-tail.svg": "7be0",
	"./arrow-down.svg": "9921",
	"./arrow-left-2.svg": "13dd",
	"./arrow-left.svg": "8055",
	"./arrow-m-left.svg": "4ff7",
	"./arrow-medium-left.svg": "d5d8",
	"./arrow-right-new.svg": "f5d3",
	"./arrow-right-small.svg": "6ee1",
	"./arrow-right.svg": "e99f",
	"./arrow-top-large.svg": "a1bb",
	"./arrow-top-small.svg": "2f7e",
	"./arrow-triangle-bottom-2.svg": "10bd",
	"./arrow-triangle-bottom.svg": "e147",
	"./arrow-triangle-top.svg": "cac0",
	"./avatar.svg": "1711",
	"./bell.svg": "75e7",
	"./bin-small-filled.svg": "fbc4",
	"./calendar-2.svg": "cc80",
	"./calendar-3.svg": "55bf",
	"./calendar.svg": "481b",
	"./call-courier.svg": "a743",
	"./call-me.svg": "10b1",
	"./chat.svg": "74fd",
	"./check-rounded.svg": "ee0e",
	"./check.svg": "23b1",
	"./check_circle.svg": "a2ec",
	"./chevron-left-no-tail.svg": "7c3a",
	"./chevron-right-no-tail.svg": "b275",
	"./chevron_down_fixed.svg": "961f",
	"./chevron_down_medium.svg": "2c36",
	"./chevron_down_small.svg": "c6c95",
	"./chevron_right.svg": "7383",
	"./chevron_right_large.svg": "8620",
	"./circle-loader.svg": "1d54",
	"./city-selector.svg": "3e2b",
	"./clock.svg": "9dbb",
	"./cross-copy-3.svg": "391c",
	"./cross-smooth.svg": "020e",
	"./cross.svg": "cfe3",
	"./curly-arrow-small.svg": "188f",
	"./cutlery.svg": "25ce",
	"./dashboard.svg": "d725",
	"./delivery-car-stroke.svg": "0cee",
	"./delivery-car.svg": "3198",
	"./delivery-check.svg": "e7ab",
	"./discount.svg": "a487",
	"./gf_about.svg": "d0b4",
	"./gf_aeroflot.svg": "d6d8",
	"./gf_books.svg": "8a06",
	"./gf_calendar.svg": "21ca",
	"./gf_fitting.svg": "2fc3",
	"./gf_muscule.svg": "c6ac",
	"./gf_payment.svg": "3e10",
	"./gf_price copy.svg": "a1e0",
	"./gf_price.svg": "6ece",
	"./gf_promo.svg": "86e8",
	"./gf_reduce.svg": "4fb7",
	"./gf_storage copy.svg": "26de",
	"./gf_storage.svg": "9905",
	"./gf_waist.svg": "86ec",
	"./gift.svg": "007e",
	"./heart-rating.svg": "75cf",
	"./heart2.svg": "796e",
	"./ic-tick.svg": "d5a3",
	"./icon-chevron-down-large.svg": "3263",
	"./icon-close-small.svg": "fd6c",
	"./icon-user.svg": "4af2",
	"./info-rounded-2.svg": "ce10",
	"./info-rounded-small.svg": "dd24",
	"./info-rounded.svg": "8be5",
	"./info.svg": "72d3",
	"./intersect.svg": "3852",
	"./lightning.svg": "bb8c",
	"./lk-loyalty.svg": "6d1f",
	"./lock.svg": "59ca",
	"./logo-one-line_simple.svg": "2d17",
	"./logo.svg": "7afa",
	"./logout.svg": "cc51",
	"./minus.svg": "5242",
	"./navbar-cart.svg": "6d0a",
	"./navbar-favorites.svg": "cd75",
	"./navbar-invite.svg": "286e",
	"./navbar-logout.svg": "f591",
	"./navbar-new-order.svg": "ce94",
	"./navbar-orders.svg": "7f97",
	"./navbar-settings.svg": "c2f6",
	"./navbar-subscribe.svg": "d8c8",
	"./navbar-wallet.svg": "f35d",
	"./new-order.svg": "330c",
	"./notifications-error-xl.svg": "09c4",
	"./pacman.svg": "159bb",
	"./page_deliveries.svg": "b36b",
	"./page_menu.svg": "6e3c",
	"./page_preferences.svg": "56d1",
	"./page_settings.svg": "b9f9",
	"./pay-aeroflot.svg": "5e25",
	"./pay-apple.svg": "c779",
	"./pay-by-cash.svg": "ab0a",
	"./pay-card.svg": "9741",
	"./pay-google.svg": "6dd9",
	"./pen.svg": "6db6",
	"./percent.svg": "e891",
	"./phone.svg": "e58f",
	"./plus.svg": "ecea",
	"./promocode.svg": "f27f",
	"./question-hover.svg": "d213",
	"./question-normal.svg": "f803",
	"./question.svg": "d49f",
	"./right.svg": "cb8d",
	"./rouble-rounded.svg": "90fd",
	"./ruble-rounded.svg": "0646",
	"./settings.svg": "408a",
	"./telegram.svg": "a9f0",
	"./thicc-cross.svg": "c59c",
	"./thumbs-down-ff.svg": "f778",
	"./thumbs-down.svg": "fb1e",
	"./thumbup.svg": "ec8a",
	"./trash-2.svg": "e5b9",
	"./trash.svg": "ad29",
	"./weigher.svg": "3118",
	"./whatsapp.svg": "32a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b4d1";